module.exports = __webpack_public_path__ + "static/img/swiperback1.862942a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/swiperback1.png
// module id = vHIe
// module chunks = 0